"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Tracking = void 0;
const mixpanel_1 = __importDefault(require("./trackers/mixpanel"));
const utils_1 = require("./utils");
class Tracking {
    constructor() {
        this._hasUser = false;
        this._superProperties = {};
        this._optedIn = false;
        this._trackQueue = [];
        this._allRegistersSet = false;
        this._currentlyRegistered = new Set([]);
    }
    isTrackable(tracker) {
        return this._config && this._config[tracker];
    }
    get hasUser() {
        return this._hasUser;
    }
    set hasUser(hasUser) {
        this._hasUser = hasUser;
    }
    get initialized() {
        return !!this._config;
    }
    setMandatoryRegisters(mandatoryRegisters) {
        this._mandatoryRegisters = mandatoryRegisters;
    }
    init(config, displayInterface) {
        if ((0, utils_1.isServerSide)())
            return;
        this._config = config;
        if (this._config.mixpanel) {
            mixpanel_1.default.init(this._config.mixpanel);
            mixpanel_1.default.register(Object.assign(Object.assign({}, this._superProperties), { Interface: displayInterface }));
        }
    }
    register(superProperties, mandatory_id) {
        this._superProperties = Object.assign(Object.assign({}, this._superProperties), superProperties);
        if (this.isTrackable('mixpanel')) {
            mixpanel_1.default.register(superProperties);
            if (mandatory_id) {
                this._currentlyRegistered.add(mandatory_id);
                if (this._mandatoryRegisters && (0, utils_1.areSetEqual)(this._currentlyRegistered, this._mandatoryRegisters)) {
                    this._allRegistersSet = true;
                    if (this._trackQueue.length > 0) {
                        let i = this._trackQueue.length;
                        while (i > 0) {
                            const event = this._trackQueue.pop();
                            mixpanel_1.default.track(event);
                            i--;
                        }
                    }
                }
            }
        }
    }
    unregister(superProperty) {
        if (this.isTrackable('mixpanel')) {
            mixpanel_1.default.unregister(superProperty);
        }
    }
    handleMember(member) {
        if ((0, utils_1.isServerSide)())
            return;
        const defaultMemberProps = member
            ? {
                '# of Completed Purchases': member.orderNumber,
                'CRM Segment': member.segmentId,
                'Member ID': member.memberId,
                'Member Optin Perso': member.persoStatusGDPR === 1,
            }
            : null;
        this._superProperties = Object.assign(Object.assign({}, this._superProperties), defaultMemberProps);
        if (this._config.mixpanel && member) {
            this.hasUser = true;
            mixpanel_1.default.setUser(member, this._superProperties);
        }
    }
    optIn() {
        this._optedIn = true;
        mixpanel_1.default.optIn();
    }
    optOut() {
        this._optedIn = false;
        mixpanel_1.default.optOut();
    }
    track(name, properties) {
        if ((0, utils_1.isServerSide)())
            return;
        const event = { name, properties };
        if (this.isTrackable('mixpanel') &&
            (this._allRegistersSet || this._mandatoryRegisters === undefined || this._mandatoryRegisters.size === 0)) {
            mixpanel_1.default.track(event);
        }
        else {
            this._trackQueue.unshift(event);
        }
    }
    get people() {
        if ((0, utils_1.isServerSide)())
            return;
        return mixpanel_1.default.people;
    }
    hasOptedIn() {
        return this._optedIn;
    }
    hasOptedOut() {
        return !this._optedIn;
    }
    getMixpanelInstance() {
        if ((0, utils_1.isServerSide)())
            return;
        return mixpanel_1.default.instance;
    }
}
exports.Tracking = Tracking;
exports.default = new Tracking();
